<template>
  <div class="top-bar-shell">
    <div class="top-bar-shell__title">
      <slot name="title">
        <ItemName v-if="!isMobile" />
      </slot>
    </div>
    <div class="top-bar-shell__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ItemName from '@/modules/viewer/components/Name.vue';
import { useMobileDetection } from '@/composables/useMobileDetection';

const { isMobile } = useMobileDetection();
</script>

<style scoped>
.top-bar-shell {
  @apply flex flex-row items-center justify-end gap-1;
}

@media (min-width: 640px) {
  .top-bar-shell {
    @apply justify-between gap-2;
  }
}

.top-bar-shell__title {
  @apply hidden sm:block flex-1 min-w-0;
}

.top-bar-shell__title :deep(h1),
.top-bar-shell__title :deep([data-testid='viewer-item-name']) {
  @apply text-xl sm:text-2xl font-semibold truncate;
}

.top-bar-shell__actions {
  @apply flex items-center gap-1 sm:gap-2 flex-shrink-0;
}
</style>
